import { Template } from "./template.js";


const Info_window = {
	data() {
		return {

			mode: 'view',
			user: null
		}
	},

	props: {
		selected: Object

	},
	methods: {
		edit() {
			this.mode = 'edit';
		},
		create() {
			this.mode = 'create';
			this.user = { name: '', email: '', group: 'user' }
		},
		save() {
			var cont = this;
			this.user.mode = this.mode;
			this.$API('users', 'updateUser', this.user,
				function(data) {
					if (data.result) {
						cont.$emit("update-user", cont.user);

						cont.mode = 'view';
					}
				},
				function(errorText) { console.log(errorText) });

		},
		del() {
			if (confirm("Вы точно хотите удалить пользователя?")) {
				var cont = this;
				this.user.mode = this.mode;
				this.user.delete = true;
				this.$API('users', 'deleteUser', this.user,
					function(data) {
						if (data.result) {
							cont.$emit("update-user", cont.user);

							cont.mode = 'view';
						}
					},
					function(errorText) { console.log(errorText) });
			}

		},

		cancel() {
			this.mode = 'view';
			this.user = JSON.parse(JSON.stringify(this.selected));
		}

	},
	watch: {

		'selected': {
			handler: function() {
				this.user = JSON.parse(JSON.stringify(this.selected));

			},

			immediate: true
		},
	},
	template: Template
}

export { Info_window }


// WEBPACK FOOTER //
// ./src/app/js/components/page3_users/info_window/component.js